.badge { font-size: var(--text-xs); font-weight: var(--weight-medium); color: var(--color-text-secondary); }
.emphasis { font-weight: var(--weight-semibold); color: var(--color-text); }
